import styled, { css } from 'styled-components';
import { Select, TextField, Button, IconButton, Modal } from '@mollybet/ui';
import CurrencyInput from 'common/components/currencyInput';
import { transparentize } from 'polished';

export const ThemedModal = styled(Modal)`
  padding: 20px;
  min-width: 300px;
  min-height: 100px;
  border-radius: 5px;
  ${(props) => css`
    font-family: ${props.theme.fonts.base};
    background: ${props.theme.cardLevel2};
    color: ${props.theme.foreground};
    box-shadow: ${props.theme.shadows[3]};
  `};
`;

const ThemedCard = styled.div`
  padding: 20px;
  border-radius: 5px;
  width: 450px;
  ${(props) => css`
    font-family: ${props.theme.fonts.base};
    color: ${props.theme.foreground};
    box-shadow: ${props.theme.shadows[3]};
  `};
`;

export const ThemedFilterCard = styled.div`
  display: inline-flex;
  flex-direction: column;
  padding: 15px;
  border-radius: 5px;
  margin-bottom: 10px;
  ${(props) => css`
    font-family: ${props.theme.fonts.base};
    color: ${props.theme.foreground};
    background: ${props.theme.cardLevel2};
    box-shadow: ${props.theme.shadows[3]};
  `};
`;

export const FilterTitle = styled.div`
  font-weight: 450;
  margin-bottom: 5px;
`;

export const FilterList = styled.div`
  display: flex;
  align-items: center;
  margin-top: 5px;

  & > * {
    margin: 0px 5px;

    &:first-child {
      margin-left: 0;
    }

    &:last-child {
      margin-right: 0;
    }
  }
`;

export const ThemedCardLevel1 = styled(ThemedCard)`
  background: ${(props) => props.theme.cardLevel1};
`;

export const ThemedCardLevel2 = styled(ThemedCard)`
  background: ${(props) => props.theme.cardLevel2};
`;

export const CardContents = styled.div`
  display: flex;
  align-items: stretch;
  flex-direction: column;
  border-radius: 5px;
  width: 450px;
`;

export const ButtonContainer = styled.div`
  display: flex;
  width: 50%;
  align-self: flex-end;
  margin: 20px 0px 10px;
`;

const StyledButton = styled(Button)`
  flex: 1;
  margin: 0px 10px;
  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const PrimaryButton = styled(StyledButton).attrs({
  variant: 'primary',
})``;

export const SecondaryButton = styled(StyledButton).attrs({
  variant: 'secondary',
})``;

export const TitleContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 20px;
`;

export const CardTitle = styled.span`
  align-self: center;
  font-weight: 450;
`;

export const CancelButton = styled(IconButton)`
  padding: 0px;
  margin: 0px;
`;

export const FormError = styled.pre`
  margin: 0;
  background-color: ${(props) => transparentize(0.9, props.theme.danger)};
  border-radius: 2px;
  box-sizing: border-box;
  padding: 1rem;
  width: 100%;
  margin-bottom: 1rem;
  color: ${(props) => props.theme.danger};
  overflow: auto;
`;

export const InputContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  margin-bottom: 10px;
`;

export const Padding = styled.div`
  flex: 1;
  margin: 0px 1em;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const Selector = styled(Select)`
  flex: 1;
  margin: 0px 1em;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const InputBox = styled(TextField)`
  flex: 1;
  margin: 0px 1em;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;

export const AmountInput = styled(CurrencyInput)`
  flex: 1;
  margin: 0px 1em;

  &:first-child {
    margin-left: 0;
  }

  &:last-child {
    margin-right: 0;
  }
`;
